import React from "react";
import CardsLink from "./CardsLink";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";


const CardsLinkHouse = props => {
    let {data, defaultItems} = props;

    return(
        <DeclinationContainerNew>
            <CardsLink data={data} place={"дома"} defaultItems={defaultItems}/>
        </DeclinationContainerNew>
    )
}

export default CardsLinkHouse;
